import { Color } from 'antd/es/color-picker';

export enum AiBotConfigFormFields {
  SENDER_NAME = 'senderName',
  MAIN_COLOR = 'mainColor',
  WELCOME_MESSAGE = 'welcomeMessage',
  DISCLAIMER_MESSAGE = 'disclaimerMessage',
}

export type TAiBotConfigFormValues = {
  [AiBotConfigFormFields.SENDER_NAME]?: string;
  [AiBotConfigFormFields.MAIN_COLOR]?: Color | string;
  [AiBotConfigFormFields.WELCOME_MESSAGE]?: string;
  [AiBotConfigFormFields.DISCLAIMER_MESSAGE]?: string;
};
